var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "msg-bell-msg-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "app-main-inner-row",
            staticStyle: { "padding-top": "10px" }
          },
          [
            _c(
              "div",
              { staticClass: "triggers" },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Search")))]),
                _c("el-input", {
                  staticStyle: { width: "200px", margin: "0 10px" },
                  attrs: { placeholder: _vm.$t("common.tips.fuzzySearch") },
                  on: {
                    input: function($event) {
                      return _vm.fastSearchHandle()
                    }
                  },
                  model: {
                    value: _vm.keyword,
                    callback: function($$v) {
                      _vm.keyword = $$v
                    },
                    expression: "keyword"
                  }
                }),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.btnAdd } },
                  [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.btnEdit } },
                  [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "danger" },
                    on: { click: _vm.btnRemoveHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass: "section grid-wrapper",
            staticStyle: { "flex-grow": "1" }
          },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%" },
              attrs: {
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                "grid-options": _vm.gridOptions,
                "side-bar": _vm.sideBarDefs
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "202405282006",
                total: _vm.pageInfo.total,
                page: _vm.pageInfo.pageNum,
                limit: _vm.pageInfo.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.pageInfo, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.pageInfo, "pageSize", $event)
                },
                pagination: _vm.loadData
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            slot: "reference",
            "close-on-click-modal": false,
            visible: _vm.showEditDialog,
            title: _vm.title,
            width: "430px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showEditDialog = $event
            },
            closed: _vm.cancelHandler,
            open: _vm.getClassifyMsg
          },
          slot: "reference"
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "dialog-tabs",
              attrs: { "tab-position": "top" },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            _vm._l(_vm.form, function(item) {
              return _c(
                "el-tab-pane",
                { attrs: { label: item.name, name: item.name } },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "dialog-tabs-form",
                      attrs: {
                        model: item,
                        "label-width": "100px",
                        size: "medium"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.ClassifyName")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "250px" },
                              attrs: { disabled: item.language !== "zh_CN" },
                              on: {
                                change: function($event) {
                                  return _vm.changeSyncClassify(item)
                                }
                              },
                              model: {
                                value: item.classifyUuid,
                                callback: function($$v) {
                                  _vm.$set(item, "classifyUuid", $$v)
                                },
                                expression: "item.classifyUuid"
                              }
                            },
                            _vm._l(_vm.selectClassifyMsgList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.classifyName,
                                  value: item.uuid
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SystemMaintenance.MsgTitle") }
                        },
                        [
                          _c("el-input", {
                            staticClass: "required-star",
                            model: {
                              value: item.title,
                              callback: function($$v) {
                                _vm.$set(item, "title", $$v)
                              },
                              expression: "item.title"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SystemMaintenance.Code") } },
                        [
                          _c("el-input", {
                            staticClass: "required-star",
                            attrs: { disabled: item.language !== "zh_CN" },
                            on: {
                              change: function($event) {
                                return _vm.changeSyncCode(item)
                              }
                            },
                            model: {
                              value: item.code,
                              callback: function($$v) {
                                _vm.$set(item, "code", $$v)
                              },
                              expression: "item.code"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SystemMaintenance.Content") }
                        },
                        [
                          _c("el-input", {
                            staticClass: "required-star",
                            attrs: { type: "textarea" },
                            model: {
                              value: item.content,
                              callback: function($$v) {
                                _vm.$set(item, "content", $$v)
                              },
                              expression: "item.content"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SystemMaintenance.Link") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "250px" },
                            attrs: { disabled: item.language !== "zh_CN" },
                            on: {
                              change: function($event) {
                                return _vm.changeSyncLink(item)
                              }
                            },
                            model: {
                              value: item.link,
                              callback: function($$v) {
                                _vm.$set(item, "link", $$v)
                              },
                              expression: "item.link"
                            }
                          }),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: _vm.$t("SystemMaintenance.LinkTip"),
                                placement: "top-end"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning",
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "#DCA550",
                                  margin: "0 5px"
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini ", type: "primary" },
                  on: { click: _vm.submitHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini " }, on: { click: _vm.cancelHandler } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }